import { StatusPill } from '../../components/primitives/StatusPill'
import { findingVerdictNote, findingVerdictView } from './completion-verdict'

interface HistoricalProps {
  revision: number
  onBackToCurrent: () => void
}

export function HistoricalVersionBanner({ revision, onBackToCurrent }: HistoricalProps) {
  return (
    <div className="mb-5 flex flex-wrap items-center gap-3 rounded-lg border border-brand bg-brand-soft px-3.5 py-2.5">
      <span className="font-mono text-10 font-semibold uppercase tracking-[0.12em] text-brand">
        Historical version
      </span>
      <p className="m-0 min-w-60 flex-1 text-xs leading-relaxed text-ink-2">
        Viewing revision {revision}. Review actions apply only to the current version.
      </p>
      <button
        type="button"
        onClick={onBackToCurrent}
        className="h-7 shrink-0 cursor-pointer rounded-md border border-brand bg-brand px-3 text-xs font-medium text-brand-fg"
      >
        Back to current
      </button>
    </div>
  )
}

interface StatusStripProps {
  status?: string | null
  reason?: string | null
  completedAtLabel?: string
}

export function FindingStatusStrip({ status, reason, completedAtLabel }: StatusStripProps) {
  const view = findingVerdictView(status)
  return (
    <div className="flex flex-wrap items-center gap-2.5 rounded-lg border border-line bg-bg-elev px-3.5 py-2.5">
      <StatusPill status={view.tone}>{view.label}</StatusPill>
      <span className="text-12 leading-snug text-ink-2">
        {findingVerdictNote({ status, reason, completedAtLabel })}
      </span>
    </div>
  )
}
